/** TrafiFlow platform pixel event names (browser SDK). */
export const TF_PIXEL_EVENTS = {
  ADD_TO_CART: 'product_added_to_cart',
  CHECKOUT_STARTED: 'checkout_started',
  IDENTIFY: 'identify_user',
  PAGE_VIEW: 'page_view',
  PRODUCT_VIEW: 'product_view',
  PURCHASE: 'purchase',
} as const;

export type TfPixelEventName = (typeof TF_PIXEL_EVENTS)[keyof typeof TF_PIXEL_EVENTS];
